import Layout from '@/components/Layout/Layout'
import Playout from '@/components/Layout/Playout'

const routeMap = [
    {
        path: '/backhome',
        component: Layout,
        name: 'backhome',
        redirect: '/backhome/home',
        children: [

            {
                path: 'home',
                name: 'home',
                component: () => import('@/views/modules/home'),
                meta: { title: '大屏首页' }
            },
            // {
            //     path: 'login',
            //     name: 'login',
            //     component: () => import('@/components/page/login'),
            //     meta: { title: '登录' }
            // },
            {
                path: 'excode',
                name: 'excode',
                component: () => import('@/views/modules/excode'),
                meta: { title: '兑换码' }
            },
            {
                path: 'userinfo',
                name: 'userinfo',
                component: () => import('@/views/modules/userinfo'),
                meta: { title: '用户信息' }
            },
            {
                path: 'friends',
                name: 'friends',
                component: () => import('@/views/modules/friends'),
                meta: { title: '与好友一起' }
            },
            {
                path: 'subscribe',
                name: 'subscribe',
                component: () => import('@/views/modules/subscribe'),
                meta: { title: '订阅' }
            },
            {
                path: 'aftersales',
                name: 'aftersales',
                component: () => import('@/views/modules/aftersales'),
                meta: { title: '售后支持' }
            },
            {
                path: 'luckdraw',
                name: 'luckdraw',
                component: () => import('@/views/modules/luckdraw'),
                meta: { title: '抽奖' }
            },
            // {
            //     path: 'wish',
            //     name: 'wish',
            //     component: () => import('@/components/page/wish'),
            //     meta: { title: '许愿' }
            // },
            // {
            //     path: 'help',
            //     name: 'help',
            //     component: () => import('@/views/modules/help'),
            //     meta: { title: '帮助中心' }
            // },
            {
                path: 'helpdetail',
                name: 'helpdetail',
                component: () => import('@/views/modules/helpdetail'),
                meta: { title: '帮助中心' }
            },
            {
                path: 'nfcode',
                name: 'nfcode',
                component: () => import('@/views/modules/nfgetcode'),
                meta: { title: '奈飞拿code' }
            },
            {
                path: 'order',
                name: 'order',
                component: () => import('@/views/modules/order'),
                meta: { title: '订单' }
            }

        ]
    },
    {
        path: "/phone",
        component: Playout,
        name: "Playout",
        redirect: "/phone/home",
        children: [
            {
                path: "home",
                name: "phonehome",
                component: () => import("@/views/modules/phome"),
                meta: { title: "手机首页" },
            },
            // {
            //     path: "phonelogin",
            //     name: "phonelogin",
            //     component: () => import("@/views/modules/plogin"),
            //     meta: { title: "手机登陆" },
            // },
            {
                path: 'phelp',
                name: 'phelp',
                component: () => import('@/views/modules/help'),
                meta: { title: '帮助中心' }
            },
            {
                path: "psubscribe",
                name: "psubscribe",
                component: () => import("@/views/modules/psubscribe"),
                meta: { title: "手机订阅" },
            },
            {
                path: 'paftersales',
                name: 'paftersales',
                component: () => import('@/views/modules/aftersales'),
                meta: { title: '售后支持' }
            },
            {
                path: 'pexcode',
                name: 'pexcode',
                component: () => import('@/views/modules/excode'),
                meta: { title: '兑换码' }
            },
            {
                path: 'phelpdetail',
                name: 'phelpdetail',
                component: () => import('@/views/modules/helpdetail'),
                meta: { title: '退款政策' }
            },
            {
                path: 'pluckdraw',
                name: 'pluckdraw',
                component: () => import('@/views/modules/luckdraw'),
                meta: { title: '抽奖' }
            },
            {
                path: 'pfriends',
                name: 'pfriends',
                component: () => import('@/views/modules/friends'),
                meta: { title: '与好友一起' }
            },
            {
                path: 'pOrder',
                name: 'pOrder',
                component: () => import('@/views/modules/order'),
                meta: { title: '订单' }
            },
            {
                path: 'puserinfo',
                name: 'puserinfo',
                component: () => import('@/views/modules/puserinfo'),
                meta: { title: '用户信息' }
            },

        ],
    },
    {
        path: '/shareAI',
        name: 'shareAI',
        component: () => import('@/views/modules/ai/shareAI'),
        meta: { title: 'shareAI' }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/pc'),
        meta: { title: 'PC端登录' }
    },
    {
        path: '/phonelogin',
        name: 'phonelogin',
        component: () => import('@/views/login/phone'),
        meta: { title: '移动端登录' }
    },
    {
        path: 'pnfcode',
        name: 'pnfcode',
        component: () => import('@/views/modules/nfgetcode'),
        meta: { title: 'p奈飞拿code' }
    },
    {   name: '404',
        path: '/404',
        hidden: true,
        component: () => import('@/views/404'),
    },
    {
        name: '403',
        path: '/403',
        hidden: true,
        component: () => import('@/views/403'),
    },
    {
        path: '*', redirect: '/404', hidden: true
    }
]


export default routeMap;
